import api from './api';

// 뉴스 관련 API 호출 함수들
export const newsApi = {
  // 뉴스 목록 조회
  getAllNews: async (page = 1, size = 20) => {
    const response = await api.getPublic(`/news?page=${page}&size=${size}`);
    return response.data;
  },

  // 뉴스 상세 조회
  getNewsById: async (id) => {
    const response = await api.getPublic(`/news/${id}`);
    return response.data;
  },

  // 슬러그로 뉴스 상세 조회
  getNewsBySlug: async (slug) => {
    const response = await api.getPublic(`/news/by-slug/${slug}`);
    return response.data;
  },

  // 뉴스 생성
  createNews: async (formData) => {
    const response = await api.postAuth('/news', formData);
    return response.data;
  },

  // 뉴스 수정
  updateNews: async (id, formData) => {
    const response = await api.putAuth(`/news/${id}`, formData);
    return response.data;
  },

  // 뉴스 삭제
  deleteNews: async (id) => {
    const response = await api.deleteAuth(`/news/${id}`);
    return response.data;
  },

  // 뉴스 댓글 목록 조회
  getComments: async (newsId) => {
    const response = await api.getPublic(`/comments?article_type=NEWS&article_id=${newsId}`);
    return response.data;
  },

  // 뉴스 댓글 작성
  addComment: async (newsId, content, parentId = null, mentionedUserId = null) => {
    const payload = {
      articleType: 'NEWS',
      articleId: Number(newsId),
      content: content,
    };

    if (parentId !== null) {
      payload.parentId = parentId;
    }
    if (mentionedUserId !== null) {
      payload.mentionedUserId = mentionedUserId;
    }

    const response = await api.postAuth('/comments', payload);
    return response.data;
  },

  // 뉴스 북마크 추가
  addBookmark: async (newsId) => {
    const response = await api.postAuth('/bookmarks', {
      itemType: 'NEWS',
      itemId: Number(newsId),
    });
    return response.data;
  },

  // 뉴스 북마크 삭제
  deleteBookmark: async (newsId) => {
    const response = await api.deleteAuth(`/bookmarks/news/${newsId}`);
    return response.data;
  },
};
